import React, { useState, useEffect, useRef } from "react";
import { View, StyleSheet } from "react-native";
import { Label, TextField, PushButton } from "../components/FormComponents";
import {
  Progress,
  ProgressDialog,
  ErrorDialog,
  SuccessDialog,
} from "../components/DialogComponents";
import { executeGet, executePost, api, resCode } from "../utilities/Network";
import { createHeaders, saveHeaders } from "../utilities/System";
import { useSelector, useDispatch } from "react-redux";
import {
  setClientConfiguration,
  setHeaderConfiguration,
  parameters,
  setUserParams,
} from "../reducers/parameterSlice";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { ForgotPasswordDialog } from "../components/DialogComponents";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import { Button } from "@mui/material";

//== LOGIN DESKTOP ==//
const Login = (props) => {
  const clientParams = useSelector(parameters);
  const dispatch = useDispatch();

  const emailRef = useRef();
  const passwordRef = useRef();

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [password, setPassword] = useState("");
  const [errorPassword, setErrorPassword] = useState(false);
  const [showForgotPasswordDialog, setShowForgotPasswordDialog] =
    useState(false);
  const initProgress = {
    showProgress: false,
    message: "Harap Tunggu",
    showError: false,
    showSuccess: false,
  };
  const [progressParams, setProgressParams] = useState(initProgress);

  useEffect(() => {
    window.electron.receiveMessage("RECEIVE_READ_TOKEN", (params) => {
      let token = params.token;
      let _progress = { ...progressParams };
      _progress.showProgress = true;
      setProgressParams(_progress);
      autoLogin(token);
    });

    if (!window.electron?.receiveMessage) return;
    window.electron.receiveMessage("SSO_CALLBACK", (params) => {
      const code = params.code;

      if (code) {
        executeSSOLogin(code);
      }
    });
  }, []);

  //NOTE - Verify App Token
  const autoLogin = async (token) => {
    const url = api.autoLogin + token;
    const response = await executeGet(url);
    let _initProgress = { ...progressParams };
    _initProgress.showProgress = false;
    setProgressParams(_initProgress);

    if (response.code == 200) {
      let data = response.data;
      global.headers.UUID = data.uuid;
      global.headers.KEY = data.token;
      global.headers.USERNAME = data.username;
      global.headers.USERLEVEL = data.level;
      global.headers.USERID = data.id_user;
      await saveHeaders(global.headers);

      if (data.hasOwnProperty("id_konten")) {
        //alert("SENDING ID KONTEN: " + data.id_konten);
        window.electron.sendMessage("SEND_ID_KONTEN", {
          id_konten: data.id_konten,
        });
      }
      _initProgress.showProgress = true;
      setProgressParams(_initProgress);
      relogin();
    }
  };

  const relogin = async () => {
    let formData = new FormData();
    formData.append("id_user", global.headers.USERID);
    const response = await executePost(api.credentials, formData);
    let _initProgress = { ...progressParams };
    _initProgress.showProgress = false;
    setProgressParams(_initProgress);

    if (response.code == resCode.ok) {
      let newHeaders = {
        CLIENTID: global.headers.CLIENTID,
        UUID: global.headers.UUID,
        OS: global.headers.OS,
        VERSIONCODE: global.headers.VERSIONCODE,
        KEY: response.token,
        USERNAME: response.data.username,
        USERID: response.data.id_user,
        USERLEVEL: response.data.level,
        MAXDAY: clientParams.max_hari,
        MAXCONTENT: clientParams.max_konten,
      };
      let userParams = {
        nama: response.data.nama,
        url_foto: response.data.url_foto,
        troli_donasi: response.data.hasOwnProperty("troli_donasi")
          ? response.data.troli_donasi
          : "0",
        troli_toko: response.data.hasOwnProperty("troli_toko")
          ? response.data.troli_toko
          : "0",
        profile_complete: response.data.profile_complete,
      };

      //setHeaderConfiguration(newHeaders);
      saveHeaders(newHeaders);
      setTimeout(() => {
        props.navigation.reset({
          index: 0,
          routes: [{ name: "Main" }],
        });
      }, 1000);
    }
  };

  //ANCHOR - Login Click
  const onLoginClick = () => {
    if (email.length < 5) {
      setErrorEmail(true);
      return;
    }

    if (password.length < 5) {
      setErrorPassword(true);
      return;
    }

    validateInput();
  };

  //ANCHOR - Confirm Click
  const resetPassword = (email) => {
    setShowForgotPasswordDialog(false);
    let formData = new FormData();
    formData.append("username", email);

    //Tampilkan Progress dialog
    let params = { ...progressParams };
    params.showProgress = true;
    params.message = "Harap Tunggu";
    setProgressParams(params);
    //Eksekusi Reset
    executeReset(formData);
  };
  //ANCHOR - Execute reset password
  const executeReset = async (formData) => {
    const response = await executePost(api.forgotPassword, formData);
    let params = { ...progressParams };

    //Sembunyikan progress dialog
    params.showProgress = false;
    if (response.code == resCode.ok) {
      params.showSuccess = true;
      params.message = response.msg;
      setProgressParams(params);
    } else {
      params.showError = true;
      params.message = response.msg;
      setProgressParams(params);
    }
  };

  //ANCHOR - On Email Press
  const onEmailPress = (event) => {
    if (event.key == "Enter") {
      passwordRef.current.focus();
    }
  };
  //ANCHOR - On Password Press
  const onPasswordPress = (event) => {
    if (event.key == "Enter") {
      validateInput();
    }
  };

  //ANCHOR - Validate Input
  const validateInput = () => {
    emailRef.current.focus();
    if (email == "" || email.length < 5) {
      setErrorEmail(true);
      emailRef.current.focus();
      return;
    }

    if (password == "" || password.length < 5) {
      setErrorPassword(true);
      passwordRef.current.focus();
      return;
    }

    //Tampilkan Progress Dialog
    let params = { ...progressParams };
    params.showProgress = true;

    params.message = "Autentikasi";
    setProgressParams(params);

    let formData = new FormData();
    formData.append("user", email);
    formData.append("pass", password);
    executeLogin(formData);
  };

  //ANCHOR - Execute Login
  const executeLogin = async (formData) => {
    const response = await executePost(api.login, formData);
    let params = { ...progressParams };
    params.showProgress = false;
    if (response.code == resCode.ok) {
      setProgressParams(params);

      let newHeaders = {
        CLIENTID: global.headers.CLIENTID,
        UUID: global.headers.UUID,
        OS: global.headers.OS,
        VERSIONCODE: global.headers.VERSIONCODE,
        KEY: response.token,
        USERNAME: response.data.username,
        USERID: response.data.id_user,
        USERLEVEL: response.data.level,
        MAXDAY: clientParams.max_hari,
        MAXCONTENT: clientParams.max_konten,
      };

      window.electron.sendMessage("SET-USERNAME", {
        username: response.data.username,
      });
      setHeaderConfiguration(newHeaders);
      saveHeaders(newHeaders);
      let userParams = {
        nama: response.data.nama,
        foto: response.data.url_foto,
        troli_donasi: response.data.hasOwnProperty("troli_donasi")
          ? response.data.troli_donasi
          : "0",
        troli_toko: response.data.hasOwnProperty("troli_toko")
          ? response.data.troli_toko
          : "0",
        profile_complete: response.data.profile_complete,
      };
      dispatch(setUserParams(userParams));
      props.navigation.reset({
        index: 0,
        routes: [{ name: "Main" }],
      });
    } else {
      params.showError = true;
      params.message = response.msg;
      setProgressParams(params);
    }
  };

  //ANCHOR - Login with SSO
  const loginWithSSO = async () => {
    const storageRaw = localStorage.getItem(`${clientParams.kode}`);
    if (!storageRaw) {
      alert("Data perangkat belum tersedia. Muat ulang aplikasi.");
      return;
    }

    const storage = JSON.parse(storageRaw);
    const os = storage.OS;
    const uuid = storage.UUID;
    const clientId = storage.CLIENTID;

    setProgressParams({
      ...progressParams,
      showProgress: true,
      showError: false,
      message: "Menyiapkan login institusi...",
    });

    try {
      const formData = new FormData();
      formData.append("kode", clientParams.kode);
      formData.append("os", os);

      const response = await fetch(api.loginWithSSO, {
        method: "post",
        headers: {
          OS: os,
          UUID: uuid,
          CLIENTID: clientId,
        },
        body: formData,
      });
      const data = JSON.parse(await response.text());

      // Tutup loading dulu, baru buka window SSO
      setProgressParams({
        ...progressParams,
        showProgress: false,
        showError: false,
      });

      if (data.code !== resCode.ok) {
        setProgressParams({
          ...progressParams,
          showProgress: false,
          showError: true,
          message: data.msg || "Gagal memulai login institusi",
        });
        return;
      }

      const url = data?.data?.auth_url;
      if (!url) {
        setProgressParams({
          ...progressParams,
          showProgress: false,
          showError: true,
          message: "URL login institusi tidak ditemukan",
        });
        return;
      }

      // SSO LKPP memblokir iframe (X-Frame-Options: deny),
      // jadi buka di window Electron / tab browser.
      if (window.electron?.sendMessage) {
        window.electron.sendMessage("OPEN_URL", url);
      } else {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      setProgressParams({
        ...progressParams,
        showProgress: false,
        showError: true,
        message: "Gagal memulai login institusi",
      });
    }
  };

  const executeSSOLogin = async (code) => {
    const storageRaw = localStorage.getItem(`${clientParams.kode}`);
    if (!storageRaw) {
      alert("Data perangkat belum tersedia. Muat ulang aplikasi.");
      return;
    }

    const storage = JSON.parse(storageRaw);
    const os = storage.OS;
    const uuid = storage.UUID;
    const clientId = storage.CLIENTID;

    setProgressParams({
      showProgress: true,
      showError: false,
      showSuccess: false,
      message: "Menyelesaikan login institusi...",
    });

    try {
      const formData = new FormData();
      formData.append("code", code);

      const response = await fetch(api.signInSSO, {
        method: "post",
        headers: {
          OS: os,
          UUID: uuid,
          CLIENTID: clientId,
        },
        body: formData,
      });

      const data = JSON.parse(await response.text());

      if (data.code == resCode.ok) {
        const userData = data.data || {};

        const newHeaders = {
          CLIENTID: global.headers.CLIENTID || clientId,
          UUID: global.headers.UUID || uuid,
          OS: global.headers.OS || os,
          VERSIONCODE: global.headers.VERSIONCODE,
          KEY: data.token || userData.token,
          USERNAME: userData.username,
          USERID: userData.id_user,
          USERLEVEL: userData.level,
          MAXDAY: clientParams.max_hari,
          MAXCONTENT: clientParams.max_konten,
        };

        if (window.electron?.sendMessage) {
          window.electron.sendMessage("SET-USERNAME", {
            username: userData.username,
          });
        }

        setHeaderConfiguration(newHeaders);
        saveHeaders(newHeaders);

        const userParams = {
          nama: userData.nama,
          foto: userData.url_foto,
          troli_donasi: userData.hasOwnProperty("troli_donasi")
            ? userData.troli_donasi
            : "0",
          troli_toko: userData.hasOwnProperty("troli_toko")
            ? userData.troli_toko
            : "0",
          profile_complete: userData.profile_complete,
        };
        dispatch(setUserParams(userParams));

        setProgressParams({
          showProgress: false,
          showError: false,
          showSuccess: false,
          message: "",
        });

        props.navigation.reset({
          index: 0,
          routes: [{ name: "Main" }],
        });
      } else {
        setProgressParams({
          showProgress: false,
          showError: true,
          showSuccess: false,
          message: data.msg || "Gagal melakukan login institusi",
        });
      }
    } catch (error) {
      setProgressParams({
        showProgress: false,
        showError: true,
        showSuccess: false,
        message: "Gagal melakukan login institusi",
      });
    }
  };

  return (
    <View style={styles.container} tabIndex={0}>
      {
        //LEFT SIDE
      }
      <View style={styles.leftSide}>
        <img
          src={clientParams.url_logo_login}
          style={{
            width: 450,
            height: "auto",
          }}
        />
      </View>
      <View style={styles.rightSide}>
        <Label
          weight={"600"}
          size={16}
          text={"Masuk ke akun anda"}
          style={{
            marginTop: 16,
            marginLeft: 16,
            marginBottom: 16,
          }}
        />
        <View
          style={{
            height: 0.5,
            backgroundColor: "silver",
            width: "100%",
            marginBottom: 16,
          }}
        />
        <TextField
          ref={emailRef}
          labelText="ID"
          marginLeft={16}
          marginRight={16}
          onChange={(text) => {
            setEmail(text);
            setErrorEmail(false);
          }}
          placeholder={"Masukkan ID pengguna"}
          error={errorEmail}
          errorText={"Harap masukkan ID anda"}
          onKeyPress={onEmailPress}
        />
        <TextField
          ref={passwordRef}
          labelText="Password"
          marginTop={16}
          marginLeft={16}
          marginRight={16}
          onChange={(text) => {
            setPassword(text);
            setErrorPassword(false);
          }}
          placeholder={"Masukkan password"}
          type={passwordVisible ? "text" : "password"}
          withIcon={true}
          icon={
            passwordVisible ? (
              <VisibilityOffOutlinedIcon />
            ) : (
              <VisibilityOutlinedIcon />
            )
          }
          onIconClick={() => {
            passwordVisible
              ? setPasswordVisible(false)
              : setPasswordVisible(true);
          }}
          error={errorPassword}
          errorText={"Harap masukkan password anda"}
          onKeyPress={onPasswordPress}
        />
        <View
          style={{
            flexDirection: "row-reverse",
            marginTop: 12,
            marginRight: 16,
            marginBottom: 16,
          }}
        >
          {clientParams.url_sso == "0" && (
            <Label
              weight={"600"}
              size={12}
              color={"#2980b9"}
              text={"Lupa Password?"}
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                setShowForgotPasswordDialog(true);
              }}
            />
          )}
        </View>
        <PushButton
          text={"Login"}
          textWeight={"400"}
          variant="contained"
          style={{
            marginLeft: 16,
            marginRight: 16,
            borderRadius: 8,
          }}
          onClick={onLoginClick}
        />
        {clientParams.url_sso == "0" && (
          <View
            style={{
              marginTop: 16,
              marginLeft: 16,
              marginRight: 16,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Label
              size={12}
              style={{ marginRight: 4 }}
              weight={"600"}
              text={"Belum punya akun?"}
            />
            <Label
              size={12}
              style={{ marginRight: 4, cursor: "pointer" }}
              weight={"600"}
              color={clientParams.warna_header}
              text={"daftar disini"}
              onClick={() => {
                props.navigation.navigate("SignUp");
              }}
            />
          </View>
        )}

        {clientParams.url_sso == "1" && (
          <View
            style={{
              marginTop: 20,
              marginLeft: 16,
              marginRight: 16,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: "100%",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <View
                style={{ flex: 1, height: 1, backgroundColor: "#eceff1" }}
              />
              <Label
                size={11}
                weight={"600"}
                color={"#90a4ae"}
                text={"atau"}
                style={{ marginLeft: 10, marginRight: 10 }}
              />
              <View
                style={{ flex: 1, height: 1, backgroundColor: "#eceff1" }}
              />
            </View>

            <View
              style={{
                width: 44,
                height: 44,
                borderRadius: 22,
                backgroundColor:
                  (clientParams.warna_header || "#2980b9") + "14",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 10,
              }}
            >
              <ApartmentOutlinedIcon
                style={{
                  fontSize: 24,
                  color: clientParams.warna_header || "#2980b9",
                }}
              />
            </View>

            <Label
              size={13}
              weight={"600"}
              text={"Login dengan Institusi"}
              textAlign={"center"}
            />
            <Label
              size={11}
              weight={"400"}
              color={"#7f8c8d"}
              text={"Gunakan akun institusi atau organisasi Anda"}
              textAlign={"center"}
              style={{ marginTop: 4, marginBottom: 12 }}
            />

            <Button
              variant="outlined"
              startIcon={<ApartmentOutlinedIcon />}
              onClick={loginWithSSO}
              style={{
                width: "100%",
                borderRadius: 8,
                textTransform: "none",
                paddingTop: 8,
                paddingBottom: 8,
                borderColor: clientParams.warna_header,
                color: clientParams.warna_header,
                fontFamily: "Poppins",
                fontWeight: "600",
                fontSize: 13,
              }}
            >
              Lanjutkan ke Institusi
            </Button>
          </View>
        )}
      </View>

      <ForgotPasswordDialog
        open={showForgotPasswordDialog}
        onCancelClick={() => {
          setShowForgotPasswordDialog(false);
        }}
        onConfirmClick={resetPassword}
      />
      <ProgressDialog
        open={progressParams.showProgress}
        message={progressParams.message}
      />
      <ErrorDialog
        open={progressParams.showError}
        message={progressParams.message}
        label={"OK"}
        onClick={() => {
          let params = { ...progressParams };
          params.showError = false;
          setProgressParams(params);
        }}
      />
      <SuccessDialog
        open={progressParams.showSuccess}
        message={progressParams.message}
        label={"OK"}
        onClick={() => {
          let params = { ...progressParams };
          params.showSuccess = false;
          setProgressParams(params);
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
    flexDirection: "row",
  },
  leftSide: {
    flex: 0.7,
    borderRightWidth: 0.3,
    borderColor: "silver",
    alignItems: "center",
    justifyContent: "center",
  },
  rightSide: {
    flex: 0.3,
    backgroundColor: "white",
  },
});

export { Login };
